import script from "./ClientList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientList.vue?vue&type=script&setup=true&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=073569e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073569e1"]])

export default __exports__